import { render, staticRenderFns } from "./battersea-exchange-phase-2-block-a.vue?vue&type=template&id=d17e092e&"
import script from "./battersea-exchange-phase-2-block-a.vue?vue&type=script&lang=js&"
export * from "./battersea-exchange-phase-2-block-a.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports